import React, { useMemo } from 'react';
import Header from '../components/Header/header.js';
import Sidebar from '../components/Sidebar/sidebar.js';
import { Outlet } from "react-router-dom";
import Footer from "../components/Footer/footer.js";

/**
 * Layout component - Main application layout
 * AuthProvider is now at App level, so no need to wrap here
 * Memoized to prevent Sidebar from rerendering on route changes
 */
const Layout = React.memo(({ children }) => {
    // Memoize style objects to prevent recreation
    const sidebarWrapperStyle = useMemo(() => ({
        overflow: 'visible',
        position: 'relative',
        zIndex: 10
    }), []);
    
    const contentStyle = useMemo(() => ({
        contain: 'layout style',
        transition: 'none',
        overflow: 'hidden',
        position: 'relative',
        zIndex: 1
    }), []);
    
    return (
        <div className="flex flex-col sm:flex-row h-screen bg-white dark:bg-[#0d1117]" style={{ position: 'relative', overflow: 'hidden' }}>
            <div className="hidden custom-860:block" style={sidebarWrapperStyle}>
                <Sidebar />
            </div>
            <div 
                className="flex-1 flex flex-col min-w-0 min-h-0"
                style={contentStyle}
            >
                <Header />
                <main className="flex-1 overflow-y-auto min-h-0 bg-white dark:bg-[#0d1117]">
                    <div className="p-4 sm:p-6 pb-16 sm:pb-20">
                        <Outlet />
                    </div>
                </main>
                <Footer />
            </div>
        </div>
    );
});

Layout.displayName = 'Layout';

export default Layout;
